import _regeneratorRuntime from "/workdir/node_modules/@babel/runtime/regenerator";
import _defineProperty from "/workdir/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/workdir/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/*!
 * Copyright (c) 2021-Present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */
function emailVerifyCallback(_x) {
  return _emailVerifyCallback.apply(this, arguments);
}

function _emailVerifyCallback() {
  _emailVerifyCallback = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(settings) {
    var authClient, idxOptions, meta, messages, resp, otp, idxResponse;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            authClient = settings.getAuthClient();
            idxOptions = {
              exchangeCodeForTokens: false // we handle this in interactionCodeFlow.js

            };
            _context.next = 4;
            return authClient.idx.getSavedTransactionMeta();

          case 4:
            meta = _context.sent;

            if (!(!meta || !meta.interactionHandle)) {
              _context.next = 9;
              break;
            }

            // Flow can not continue in this tab. Create a synthetic server response and use it to display a message to the user
            messages = {
              type: 'array',
              value: [// terminal-return-otp-only-no-location.json
              {
                'message': 'Enter the OTP in your original browser or device.',
                'i18n': {
                  'key': 'idx.enter.otp.in.original.tab'
                },
                'class': 'INFO'
              }]
            };
            resp = {
              neededToProceed: [],
              // OKTA-382410 so bad that has to leverage rawIdxState
              rawIdxState: {
                messages: messages
              },
              context: {
                messages: messages
              }
            };
            return _context.abrupt("return", resp);

          case 9:
            // Proceed using the OTP code
            otp = settings.get('otp');
            _context.next = 12;
            return authClient.idx.proceed(_objectSpread(_objectSpread({}, idxOptions), {}, {
              otp: otp
            }));

          case 12:
            idxResponse = _context.sent;
            return _context.abrupt("return", idxResponse);

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _emailVerifyCallback.apply(this, arguments);
}

export { emailVerifyCallback };